import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {ChangeLocalizationValuesCommand} from "./changeLocalizationValues.command";

export class SetAttributeLocalizationCommand extends CommandBase {
    uid: string;
    id: string;

    constructor(uid: string, id: string) {
        super();
        this.uid = uid;
        this.id = id;
    }

    execute(data: RemoteConstantsModel): boolean {
        // Instance name keyed by uid
        new ChangeLocalizationValuesCommand(this.uid, this.id).execute(data);
        // Shared description template keyed by id (only create if it doesn't exist)
        const lang = Object.keys(data.localization)[0];
        if (lang && !((`${this.id}.description`) in data.localization[lang])) {
            new ChangeLocalizationValuesCommand(`${this.id}.description`, `${this.id} description`).execute(data);
        }
        return true;
    }
}